import { Component, Input, OnInit } from "@angular/core";
import { ListEntityModel, ParticipationState } from "app/interfaces";

@Component({
  selector: "app-participant-card",
  templateUrl: "./participant-card.component.html",
  styleUrls: ["./participant-card.component.scss"],
})
export class ParticipantCardComponent implements OnInit {
  @Input() participant!: ListEntityModel;
  @Input() canMessageSelection!: boolean;
  @Input() showEmail: boolean = true;

  get state() {
    return ParticipationState[this.participant.state];
  }

  constructor() { }

  ngOnInit() { }
}
